import { useCheckWelloApp } from '@/hooks/useCheckWelloApp';
import { MESSAGE_KEYWORD, useHandleApp } from '@/modules/wello-app';

export const useHaptic = () => {
  const { isWelloApp } = useCheckWelloApp();
  const { request: requestAppHaptic } = useHandleApp({
    type: MESSAGE_KEYWORD.HAPTIC,
  });

  const triggerHaptic = () => {
    if (isWelloApp) {
      requestAppHaptic();
    } else {
      navigator.vibrate?.(10);
    }
  };

  return { triggerHaptic };
};
